import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { server } from "../../common";
import { IoMdShare } from "react-icons/io";
import { shareurl } from "../../config";
import ShareModal from "../../ShareModal";

const TalkDetail = () => {
  document.title = "Talks";

  const { id } = useParams();
  const [talk, setTalk] = useState(null);
  const [showShareModal, setShowShareModal] = useState(false);
  const [sharedUrl, setSharedUrl] = useState("");
  const [sharedTitle, setSharedTitle] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getyuvatalks();
    getIndustrytalks();
  }, [id]);

  // Function to open the Share modal
  const openShareModal = (url, title) => {
    setSharedUrl(shareurl);
    setSharedTitle(title);
    setShowShareModal(true);
  };

  // Function to close the Share modal
  const closeShareModal = () => {
    setShowShareModal(false);
  };

  // YUVASARATHI
  const getyuvatalks = () => {
    server
      .get(`/talk/gettalk/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalk(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // industry
  const getIndustrytalks = () => {
    server
      .get(`/talk/getind_talk/${id}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        console.log("api response", response.data);
        if (response.status === 200 || response.status === 201) {
          setTalk(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  if (!talk) {
    return (
      <div>
        {loading && (
          <div className="loader-container">
            <div className="loader"></div>
          </div>
        )}
      </div>
    );
  }

  return (
    <>
      <div style={{ marginTop: "1rem" }}>
        <div className="container py-4 shadow p-4">
          <div className="row">
            <div className="">
              <div className="row">
                <div className="col-md-8">
                  <h3>{talk.title}</h3>
                </div>
                <div className="col-md-4 text-end">
                  <p className="text-end fs-3">
                    <IoMdShare onClick={() => openShareModal(talk.title)} />
                  </p>
                </div>
              </div>
              <div className="">
                {/* <iframe
                src="https://www.youtube.com/embed/AygBQ52Myoo"
                title="Watch LIVE: #MannKiBaat 103rd Episode on 30 July 2023"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
              ></iframe> */}
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <img src={talk.image} className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src={talk.image} className="d-block w-100" alt="..." />
                  </div>
                  <div className="carousel-item">
                    <img src={talk.image} className="d-block w-100" alt="..." />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-md-3 text-center">
            <h5>What's New</h5>
            <div
              id="carouselExampleControls"
              className="carousel slide mt-4"
              data-bs-ride="carousel"
            >
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={talk.image} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={talk.image} className="d-block w-100" alt="..." />
                </div>
                <div className="carousel-item">
                  <img src={talk.image} className="d-block w-100" alt="..." />
                </div>
              </div>
              <button
                className="carousel-control-prev"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="prev"
              >
                <span
                  className="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                className="carousel-control-next"
                type="button"
                data-bs-target="#carouselExampleControls"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div> */}
            <div className="my-3">
              <h3>{talk.title}</h3>
              <p>
                <b>Category:</b> {talk.category}
              </p>
              <p>{talk.description}</p>
              <h5>
                <a
                  href={talk.links}
                  target="_blank"
                  className="banner text-white p-2 rounded-3"
                >
                  Watch Video
                </a>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <ShareModal
        showModal={showShareModal}
        handleClose={closeShareModal}
        url={`https://yuvasarathi.com/#/talks/${id}`}
        title={sharedTitle}
      />
    </>
  );
};

export default TalkDetail;
